// Benepack OMS · PermGuard · 路由 + 菜单可见性
// SSOT: docs/rbac.md · permission code format <resource>:<action>
// 用法:
//   <PermGuard perm="customer:read"><MyComponent /></PermGuard>
//   <PermGuard anyOf={['customer:create','customer:update']}>...</PermGuard>
// 路由级: routes.tsx 用 <PermGuardRoute> wrapper · 不命中跳 /forbidden
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/hooks/use-auth';
import type { ReactNode } from 'react';

export interface PermGuardProps {
  perm?: string;
  anyOf?: string[];
  fallback?: ReactNode;
  children: ReactNode;
}

export function PermGuard({ perm, anyOf, fallback = null, children }: PermGuardProps) {
  const { hasPerm, hasAnyPerm } = useAuth();
  const ok = perm ? hasPerm(perm) : anyOf ? hasAnyPerm(anyOf) : true;
  return <>{ok ? children : fallback}</>;
}

export interface PermGuardRouteProps {
  perm?: string;
  anyOf?: string[];
}

export function PermGuardRoute({ perm, anyOf }: PermGuardRouteProps) {
  const { hasPerm, hasAnyPerm } = useAuth();
  const ok = perm ? hasPerm(perm) : anyOf ? hasAnyPerm(anyOf) : true;
  if (!ok) return <Navigate to="/forbidden" replace />;
  return <Outlet />;
}
